import React from 'react';

import { BlockWrapper } from '../blockWrapper';

const Advertising = ({
  blockConfig,
  full2,
  full2c,
  full3,
  full5,
  full3c,
  half2,
  full5c,
  half2c,
  half3,
  half5,
  half3c,
  half5c,
  heading2,
  heading1,
  smallText,
}) => {
  return (
    <BlockWrapper {...blockConfig} className='grid grid-cols-14'>
      <div className='col-start-2 col-end-14 hidden md:block'>
        <h3 className='font-medium text-4xl leading-4xl'>{heading1}</h3>

        <div className='grid grid-cols-12 mt-16 pb-5 text-center border-b border-grey'>
          <div className='col-start-1 col-end-5 flex items-end'>
            <p className='font-semibold text-base text-left'>Size</p>
          </div>
          <div className='col-start-5 col-span-2'>
            <p className='font-semibold text-base'>
              International Series
              <br />3 Concerts
            </p>
          </div>
          <div className='col-start-8 col-span-2'>
            <p className='font-semibold text-base'>
              Matinée Series
              <br /> 2 Concerts
            </p>
          </div>
          <div className='col-start-11 col-span-2'>
            <p className='font-semibold text-base'>
              Both Series
              <br /> 5 Concerts
            </p>
          </div>
        </div>

        <div className='grid grid-cols-12 py-5 text-center border-b border-grey'>
          <div className='col-start-1 col-end-5 flex items-end'>
            <p className='font-semibold text-base text-left'>Full Page</p>
          </div>
          <div className='col-start-5 col-span-2'>
            <p className='text-base'>{full3}</p>
          </div>
          <div className='col-start-8 col-span-2'>
            <p className='text-base'>{full2}</p>
          </div>
          <div className='col-start-11 col-span-2'>
            <p className='text-base'>{full5}</p>
          </div>
        </div>

        <div className='grid grid-cols-12 py-5 text-center border-b border-grey'>
          <div className='col-start-1 col-end-5 flex items-end'>
            <p className='font-semibold text-base text-left'>Half Page</p>
          </div>
          <div className='col-start-5 col-span-2'>
            <p className='text-base'>{half3}</p>
          </div>
          <div className='col-start-8 col-span-2'>
            <p className='text-base'>{half2}</p>
          </div>
          <div className='col-start-11 col-span-2'>
            <p className='text-base'>{half5}</p>
          </div>
        </div>

        {/* Colour Advertising */}
        <h3 className='font-medium text-4xl leading-4xl mt-24'>{heading2}</h3>

        <div className='grid grid-cols-12 mt-16 pb-5 text-center border-b border-grey'>
          <div className='col-start-1 col-end-5 flex items-end'>
            <p className='font-semibold text-base text-left'>Size</p>
          </div>
          <div className='col-start-5 col-span-2'>
            <p className='font-semibold text-base'>
              International Series
              <br />3 Concerts
            </p>
          </div>
          <div className='col-start-8 col-span-2'>
            <p className='font-semibold text-base'>
              Matinée Series
              <br /> 2 Concerts
            </p>
          </div>
          <div className='col-start-11 col-span-2'>
            <p className='font-semibold text-base'>
              Both Series
              <br /> 5 Concerts
            </p>
          </div>
        </div>

        <div className='grid grid-cols-12 py-5 text-center border-b border-grey'>
          <div className='col-start-1 col-end-5 flex items-end'>
            <p className='font-semibold text-base text-left'>Full Page</p>
          </div>
          <div className='col-start-5 col-span-2'>
            <p className='text-base'>{full3c}</p>
          </div>
          <div className='col-start-8 col-span-2'>
            <p className='text-base'>{full2c}</p>
          </div>
          <div className='col-start-11 col-span-2'>
            <p className='text-base'>{full5c}</p>
          </div>
        </div>

        <div className='grid grid-cols-12 py-5 text-center border-b border-grey'>
          <div className='col-start-1 col-end-5 flex items-end'>
            <p className='font-semibold text-base text-left'>Half Page</p>
          </div>
          <div className='col-start-5 col-span-2'>
            <p className='text-base'>{half3c}</p>
          </div>
          <div className='col-start-8 col-span-2'>
            <p className='text-base'>{half2c}</p>
          </div>
          <div className='col-start-11 col-span-2'>
            <p className='text-base'>{half5c}</p>
          </div>
        </div>

        <div className='mt-16'>
          {smallText.map((line, i) => (
            <p key={i} className='text-sm leading-sm mb-2'>
              {line}
            </p>
          ))}
        </div>
      </div>

      {/* Mobile */}
      <div className='md:hidden col-start-2 col-end-14'>
        <h3 className='font-medium text-xl leading-xl'>{heading1}</h3>
        <div className='grid grid-cols-12 mt-10 pb-5 text-center'>
          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pb-1'>
            <p className='font-semibold text-sm text-left'>Size</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pb-1'>
            <p className='font-semibold text-sm'>
              International Series
              <br />3 Concerts
            </p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Full Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{full3}</p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Half Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{half3}</p>
          </div>
        </div>

        <div className='grid grid-cols-12 mt-10 pb-5 text-center'>
          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pb-1'>
            <p className='font-semibold text-sm text-left'>Size</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pb-1'>
            <p className='font-semibold text-sm'>
              Matinée Series
              <br /> 2 Concerts
            </p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Full Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{full2}</p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Half Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{half2}</p>
          </div>
        </div>

        <div className='grid grid-cols-12 mt-10 pb-5 text-center'>
          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pb-1'>
            <p className='font-semibold text-sm text-left'>Size</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pb-1'>
            <p className='font-semibold text-sm'>
              Both Series
              <br /> 5 Concerts
            </p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Full Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{full5}</p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Half Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{half5}</p>
          </div>
        </div>

        {/* Colour Section */}
        <h3 className='font-medium text-xl leading-xl mt-16'>{heading2}</h3>
        <div className='grid grid-cols-12 mt-10 pb-5 text-center'>
          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pb-1'>
            <p className='font-semibold text-sm text-left'>Size</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pb-1'>
            <p className='font-semibold text-sm'>
              International Series
              <br />3 Concerts
            </p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Full Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{full3c}</p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Half Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{half3c}</p>
          </div>
        </div>

        <div className='grid grid-cols-12 mt-10 pb-5 text-center'>
          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pb-1'>
            <p className='font-semibold text-sm text-left'>Size</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pb-1'>
            <p className='font-semibold text-sm'>
              Matinée Series
              <br /> 2 Concerts
            </p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Full Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{full2c}</p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Half Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{half2c}</p>
          </div>
        </div>

        <div className='grid grid-cols-12 mt-10 pb-5 text-center'>
          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pb-1'>
            <p className='font-semibold text-sm text-left'>Size</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pb-1'>
            <p className='font-semibold text-sm'>
              Both Series
              <br /> 5 Concerts
            </p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Full Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{full5c}</p>
          </div>

          <div className='col-start-1 col-end-5 flex items-end border-b border-grey pt-4 pb-1'>
            <p className='font-semibold text-sm text-left'>Half Page</p>
          </div>
          <div className='col-start-5 col-end-13 border-b border-grey pt-4 pb-1'>
            <p className='text-sm'>{half5c}</p>
          </div>
        </div>
      </div>
    </BlockWrapper>
  );
};

export default Advertising;
